import { render, staticRenderFns } from "./associationChannel.vue?vue&type=template&id=2ba47a82&scoped=true"
import script from "./associationChannel.vue?vue&type=script&lang=js"
export * from "./associationChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba47a82",
  null
  
)

export default component.exports